<div class="ticket-container">
  <div
    #ticketItem
    class="ticket-items"
    *ngFor="let coupon of activeCouponesList; let i = index"
  >
    <div class="ticket ticket-disabled">
      <span class="ticket-status">معطل</span>
      <!-- Left perforations -->
      <div class="perforations left">
        <div *ngFor="let j of perforationArrays[i]" class="circle"></div>
      </div>

      <!-- Main Content -->
      <div class="content">
        <div class="d-flex justify-content-between align-items-center">
          <span
            class="text-red coupon-discound cursor-pointer"
            (click)="toggleDetails(coupon, i)"
          >
            {{ "discount" | translate }} {{ coupon.coupon_value }}
            <span *ngIf="coupon.coupon_type == 'discount_percentage'"> % </span>
            <span *ngIf="coupon.coupon_type == 'discount_constant'">
              {{ productService?.Currency.currency }}
            </span>
          </span>
          <button class="btn btn-copy" (click)="copyCouponCode(coupon.code)">
            {{ "copy code" | translate }}
          </button>
        </div>
        <div
          class="d-flex justify-content-between align-items-center"
          style="padding-bottom: 7px"
        >
          <p class="m-0 cursor-pointer" (click)="toggleDetails(coupon, i)">
            {{
              "minOrder"
                | translate
                  : { orderCount: coupon.minimum_value_coupon_application || 0 }
            }}
          </p>
          <span
            class="coupon-code cursor-pointer"
            (click)="copyCouponCode(coupon.code)"
            >{{ coupon.code }}</span
          >
        </div>
        <div
          class="d-flex justify-content-between align-items-center cursor-pointer"
          (click)="toggleDetails(coupon, i)"
        >
          <a class="btn-toggle">
            {{
              coupon.isExpanded
                ? ("show-less" | translate)
                : ("show-more" | translate)
            }}
            <i class="fa fa-solid fa-chevron-down"></i>
          </a>
          <div
            class="countdown-container"
            *ngIf="
              coupon.show_date_end == '1' &&
              coupon.coupon_end_date &&
              isOfferValid(coupon.coupon_end_date)
            "
          >
            <div>
              <span class="valid-even">{{ "valid even" | translate }} </span>
              <span class="d-block text-white">
                {{ coupon.coupon_end_date | date : "dd/MM/yyyy" }}
              </span>
            </div>
            <app-timer [offerEndDate]="coupon.coupon_end_date"></app-timer>
          </div>
        </div>
        <div
          [ngClass]="{
            'd-none': !coupon.isExpanded,
            'd-block': coupon.isExpanded
          }"
        >
          <hr />
          <div class="sub-title-desc" [innerHTML]="coupon.description"></div>
        </div>

        <!-- Right perforations -->
        <div class="perforations right">
          <div *ngFor="let j of perforationArrays[i]" class="circle"></div>
        </div>
      </div>
    </div>
  </div>
</div>
